export function applyMapContext({
    map,
    context,
    stores
}) {
    if (!context || !map) return;

    // ---------------------------
    // MAP VIEW
    // ---------------------------
    if (context.map) {
        const { center, zoom, pitch, bearing } = context.map;

        if (center || zoom || pitch || bearing) {
            map.easeTo({
                center: center ?? map.getCenter(),
                zoom: zoom ?? map.getZoom(),
                pitch: pitch ?? map.getPitch(),
                bearing: bearing ?? map.getBearing(),
                duration: 600
            });
        }
    }

    // ---------------------------
    // AOI
    // ---------------------------
    if (context.aoiId && stores.aoi) {
        stores.aoi.selectAoi(context.aoiId);
    }

    // ---------------------------
    // LAYERS
    // ---------------------------
    // ---------------------------
    // LAYERS (useLayersStore-compatible)
    // ---------------------------
    if (context.layers && stores.layers) {
        const { visibleById, toggleLayer, setOpacity } = stores.layers;

        context.layers.forEach(l => {
            // Handle visibility via toggle (idempotent)
            if (typeof l.visible === "boolean") {
                const isVisible = !!visibleById[l.id];

                if (isVisible !== l.visible) {
                    toggleLayer(l.id);
                }
            }

            // Handle opacity
            if (l.opacity != null && typeof setOpacity === "function") {
                setOpacity(l.id, l.opacity);
            }
        });
    }

    // ---------------------------
    // IMAGERY
    // ---------------------------
    if (context.imagery && stores.imagery) {
        context.imagery.forEach(i => {
            stores.imagery.enableDataset(i.datasetKey);

            if (i.opacity != null) {
                stores.imagery.setOpacity(i.datasetKey, i.opacity);
            }
        });
    }

    // ---------------------------
    // FILTERS
    // ---------------------------
    if (context.filters && stores.filters) {
        stores.filters.applyFilters(context.filters);
    }

    // ---------------------------
    // UI
    // ---------------------------
    if (context.ui?.openPanel && stores.ui) {
        stores.ui.openPanel(context.ui.openPanel);
    }
}